import { IUser } from "src/@types/users";
import { RegistrationFields } from "src/page-components/auth/RegistrationForm/types";

export const getInitialValuesForSettings = (user: IUser) => ({
  [RegistrationFields.country]: user.host.location.country.slug,
  [RegistrationFields.companyName]: user.host.company_name,
  [RegistrationFields.companyAddress]: user.host.company_address,
  [RegistrationFields.website]: user.website,
  [RegistrationFields.firstName]: user.host.first_name,
  [RegistrationFields.lastName]: user.host.last_name,
  [RegistrationFields.industry]: user?.industry?.slug,
  [RegistrationFields.description]: user.description,
  [RegistrationFields.international]: user?.international,
  [RegistrationFields.reprecentionCountries]: user?.reprecention_countries.map(
    ({ slug }) => slug
  ),
  [RegistrationFields.phoneNumber]: user.host.phone_number,
  [RegistrationFields.password]: "",
});
